import { z } from 'zod';

import { passwordRequirements } from '../../passwordRequirements.ts';

export const schema = z.object({
  email: z
    .string()
    .min(1, { message: 'required' })
    .pipe(z.email({ message: 'notValid' })),
  password: z
    .string()
    .min(1, { message: 'required' })
    .refine((value) => passwordRequirements.every((requirement) => requirement.check(value)), 'notValid'),
});

export type FormSignup = z.infer<typeof schema>;
